import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { projectDeployApi } from 'apis/platform/projectDeployApis';
import { completeState } from 'utils/constant';
import { IDeployStoryProps } from 'utils/types/platformTypes';
import DefaultLayout from 'components/layout/DefaultLayout';
import MainTable from 'components/table/MainTable';
import LiveDeployModal from './LiveDeployModal';
import CapsuleButton from 'components/button/CapsuleButton';
import TableToolbar from 'components/table/TableToolbar';
import SearchInput from 'components/search/SearchInput';
/**
 * * 플랫폼 관리 - 작품 배포 목록
 */

interface ProjectInterface {
  total: number;
  list: IDeployStoryProps[];
  title: string;
}

const StoryDeployListPage = () => {
  const [cookies] = useCookies();
  const [projectList, setProjectList] = useState<ProjectInterface[]>();
  const [record, setRecord] = useState<IDeployStoryProps>(); // 선택한 작품 정보
  const [searchData, setSearchData] = useState();
  const [visible, setVisible] = useState<boolean>(false);

  const handleOpenModal =
    (record: React.SetStateAction<IDeployStoryProps | undefined>) => () => {
      setVisible(true);
      setRecord(record);
    };

  const fetchData = async () => {
    const response = await projectDeployApi.read();
    setProjectList(response.list);
  };

  const columnsOrigin = [
    {
      title: '작품명',
      dataIndex: 'title',
      width: '40rem',
      sorter: (a, b) =>
        a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }),
    },
    {
      title: '상태',
      dataIndex: 'is_complete',
      filters: completeState,
      onFilter: (value, record) => record?.is_complete === value,
      width: '10rem',
      render: (text: string, record: IDeployStoryProps) => {
        return <>{record.is_complete === 1 ? '완결' : '연재'}</>;
      },
    },
    {
      title: '배포 날짜',
      dataIndex: 'displayTime',
      sorter: (a, b) =>
        a.displayTime.localeCompare(b.displayTime, undefined, {
          sensitivity: 'base',
        }),
      width: '10rem',
    },
    {
      title: 'LIVE 배포',
      width: '10rem',
      align: 'center',
      render: (text: string, record: IDeployStoryProps) => (
        <CapsuleButton
          onClick={handleOpenModal(record)}
          disabled={JSON.parse(cookies.platformAuth)}
        >
          배포
        </CapsuleButton>
      ),
    },
  ];

  useEffect(() => {
    fetchData().catch(console.log);
  }, []);
  return (
    <DefaultLayout>
      <TableToolbar>
        <SearchInput
          placeholder={'작품명을 검색하세요'}
          setSearchData={setSearchData}
        />
      </TableToolbar>
      <MainTable
        columns={columnsOrigin}
        dataSource={
          searchData
            ? projectList?.filter(
                (data) => data?.title?.indexOf(searchData) !== -1,
              )
            : projectList
        }
      />

      <LiveDeployModal
        record={record}
        fetchData={fetchData}
        visible={visible}
        setVisible={setVisible}
      />
    </DefaultLayout>
  );
};

export default StoryDeployListPage;
